function logoRedirect() {
    setTimeout(()=>{
        const redirectUrl = 'https://protego.ae/home-page.html';
        const logos = document.querySelector(".sk-header-content a > img");
        if(logos){
            logos.addEventListener("click", (event) => {
                event.preventDefault();
                window.location = redirectUrl;
            });
        }
    }
    , 1000);
};

export { logoRedirect };